import { DEFAULT_ITEM_HEIGHT } from '@atlassian/jira-software-roadmap-timeline-table/src/common/constants.tsx';
import type { APIProps as TableProps } from '@atlassian/jira-software-roadmap-timeline-table/src/view.tsx';

// Height of the item component
export const itemHeight: TableProps['itemHeight'] = DEFAULT_ITEM_HEIGHT;

// Base prefix for all table html element ids and style marshal classes
const scope: TableProps['scope'] = 'jwm-timeline';

// Controls features related to creating items after the last row
const isCreateLastEnabled: TableProps['isCreateLastEnabled'] = true;

// Determines whether the list can be resized, including reacting to window resizes. The listWidth prop is still respected.
const isResizeEnabled: TableProps['isResizeEnabled'] = true;

const isSelectEnabled: TableProps['isSelectEnabled'] = false;

const isDragEnabled: TableProps['isDragEnabled'] = true;

// Determines whether to show visual elements derived from the today prop (e.g. TodayMarker)
const isHighlightToday: TableProps['isHighlightToday'] = true;

// Determines whether to hide the custom scrollbars in the chart (scrolling will still be enabled)
const isHideScrollbar: TableProps['isHideScrollbar'] = false;

export const timelineProps = {
	itemHeight,
	scope,
	isCreateLastEnabled,
	isResizeEnabled,
	isSelectEnabled,
	isDragEnabled,
	isHighlightToday,
	isHideScrollbar,
} as const;

// List item menu options id
export const CHANGE_PARENT_ISSUE = 'CHANGE_PARENT_ISSUE' as const;
export const REMOVE_DATES = 'REMOVE_DATES' as const;
export const REMOVE_DUE_DATE = 'REMOVE_DUE_DATE' as const;
export const REMOVE_START_DATE = 'REMOVE_START_DATE' as const;
export const REMOVE_START_DATE_AND_DUE_DATE = 'REMOVE_START_DATE_AND_DUE_DATE' as const;
export const EDIT_DATES = 'EDIT_DATES' as const;
export const EDIT_DEPENDENCY = 'EDIT_DEPENDENCY' as const;
export const SCHEDULING_SECTION = 'schedulingSection' as const;
